import "./spinner.scss";

export const Spinner = () => {
  return <span className="nb-spinner"></span>;
};
